import http from "./controllerFetch";

class prodottiService {
    getAll() {
        return http.get('Prodotto/readProdotto');
    }
    getCatAll() {
        return http.get('Categoria/readCategoria');
    }

    create({imgProd , datiCrea ,docProd}) {
        let dati = {
            ...datiCrea,
            img : imgProd.map(img => img.id) ,
            doc : docProd.map(doc => doc.id) 
        }
        return http.post('Prodotto/creaProdotto',  dati ,
        {
            headers: {
                'content-type': 'multipart/form-data',
                //'Authorization' : 'Bearer ' + localStorage.getItem('accessToken')
            }
        });
    }

    update(imgProd ,datiModifica ,docProd) {
        let dati = {
            ...datiModifica
        }
        if (imgProd) {
            dati.img = imgProd.map(img => img.id)
        }
        if (docProd) {
            dati.doc = docProd.map(doc => doc.id)
        }
        return http.put('Prodotto/updateProdotto', dati);
    }

    get( params = {}) {
        return http.get('Prodotto/readProdotto', { params });
    }

    readQtProdottoId( params = {}) {
        return http.get('Prodotto/readQtProdottoId', { params });
    }

    creaRigaPrimaImportazione(data) {
        return http.post('Prodotto/creaRigaPrimaImportazione', data);
    }

    createAssPosMg(data) {
        return http.post('AssPosMg/creaAssPosMg', data);
    }

    updateAssPosMg(data) {
        return http.put('AssPosMg/updateAssPosMg', data);
    }

    editQtProdottoId(data) {
        return http.put('Prodotto/editQtProdottoId', data);
    }

    getAssPosMg( params = {}) {
        return http.get('AssPosMg/readAssPosMg', { params });
    }

    salvaInvetarioProd(data) {
        return http.post('Prodotto/salvaInvetarioProd', data);
    }

    editInvetarioProd(data) { 
        return http.post('Prodotto/editInvetarioProd', data);
    }

    eliminaInventario(data) { 
        return http.post('Prodotto/eliminaInventario', data);
    }

    calcolaQtIniziale( params = {}) {
        return http.get('Prodotto/calcolaQtIniziale', { params });
    }

}

export default new prodottiService();